import { Box, Container } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

/** Layout for app error pages. */
export default function ErrorLayout({ children }: Props) {
  return (
    <Container maxWidth='md'>
      <Box sx={{ py: 5 }}>{children}</Box>
    </Container>
  );
}
